module.exports = __webpack_public_path__ + "static/media/64.a07bc1e.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/64.wav
// module id = 18X8
// module chunks = 0